import {getJWTToken,getLoggedUser} from "~/helpers";
import {MENU as menu} from '~/api/menu'

export default function ({ store, redirect, app,route } ) {
  if (!store.state.auth.connected && !getJWTToken()) {
    return redirect('/auth/connexion');
  }else{
    let path = (route.path.endsWith('/') && route.path.length > 1)? route.path.slice(0, -1) : route.path;
    let paths = allowedpaths();
    if (!paths.includes(path) ) {
      return redirect(paths[0]);
    }
  }
}

function allowedpaths() {
  if(!getLoggedUser()){
    return []
  }
  const role = getLoggedUser().role;
  return (menu.filter(elem => elem.roles.includes(role))).map(elem => elem.path);
}
